import { Component } from '@angular/core';
import { ClarifyChallengeComponent } from '../clarify-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-clarify-goal',
  templateUrl: './clarify-goal.component.html',
  styleUrls: ['./clarify-goal.component.scss']
})
export class ClarifyGoalComponent {

  constructor(public clarifyChallengeComponent: ClarifyChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.clarifyChallengeComponent?.breakthrough_content || [];
    this.aiService.openSidebar(
      'clarify', 'goal', context,
      'Generate 5 goal statements {persona} for a creative challenge breakthrough. Current context: {context}',
      'dupli_breakthrough_content', this.clarifyChallengeComponent
    );
  }
}
